import styled from "styled-components";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import request from "../../../../../api/request";
import Grid2Groups from "../../../../../components/Grid2Groups";
import FormStringInput from "../../../../../components/FormControls/FormStringInput";
import FormSelectWithLabel from "../../../../../components/FormControls/FormSelectWithLabel";
import FormNumberInputNoSpinner from "../../../../../components/FormControls/FormNumberInputNoSpinner";
import FormCheckBoxWithRightLabel from "../../../../../components/FormControls/FormCheckBoxWithRightLabel";
import { NotificationManager } from 'react-notifications';
import TabBar from "../../../../../components/TabBar";
import { useNavigate } from 'react-router-dom';

const StyledAccountSectionCodes = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 750px;
    box-sizing: border-box;
    min-height: 526px;
    padding: 30px;
    margin-bottom: 30px;
    margin-left: 30px;
    color: ${(props) => props.theme.color.gray};
`;

function AccountSectionCodes(props) {

    let defaultPath = '/systemstructure/accountsectioncodes/';

    let defaultTabPath = '';
    let {subTabPath} = useParams();
    const navigate = useNavigate();

    let currentYear = new Date().getFullYear();

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isFetchedAccountTypes, setIsFetchedAccountTypes] = useState(false);
    const [tabs, setTabs] = useState([]);
    const [analysisCodes, setAnalysisCodes] = useState([]);
    const [selectedFundTypeCode, setSelectedFundTypeCode] = useState('');
    const [selectedAnalysisCode, setSelectedAnalysisCode] = useState(null);
    const [selectedAnalysisCodeId, setSelectedAnalysisCodeId] = useState(null);
    const [isAddAnalysisCodeMode, setIsAddAnalysisCodeMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Code', type: 'String', width: 100, textAlign: 'center'},
        {id: 'Description', type: 'String', width: 200, textAlign: 'left'},
    ]);
    const [gridData, setGridData] = useState({groups: [{name: 'Type: Branches', subGroups: []}, {name: 'Type: Sub-branches', subGroups: []}], items: [[[]], [[]]]});

    const [recordType, setRecordType] = useState(1);
    const [accountingYear, setAccountingYear] = useState(props.baseYear);
    const [sectionName, setSectionName] = useState('');
    const [analysisCodeDescription, setAnalysisCodeDescription] = useState('');
    const [analysisCode, setAnalysisCode] = useState('');
    const [receiptPayment, setReceiptPayment] = useState(1);
    const [accountCode, setAccountCode] = useState('');
    const [VATAccountType, setVATAccountType] = useState(0);
    const [journalUsage, setJournalUsage] = useState(0);
    const [allowSubAnalysisCodes, setAllowSubAnalysisCodes] = useState(false);
    const [isTransfers, setIsTransfers] = useState(false);
    const [doNotDisplay, setDoNotDisplay] = useState(false);
    
    const [accountSections, setAccountSections] = useState([]);
    const [sectionNameStrings, setSectionNameStrings] = useState([]);
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isAddingDuplicatedAnalysisCode, setIsAddingDuplicatedAnalysisCode] = useState(false);
    
    let years = [];
    for (let i = currentYear - 10; i < currentYear + 5; i ++) {
        years.push(i);
    }

    let branchTypes = ['Branch', 'Sub-Branch'];
    const branchTypeStringToInt = (branchTypeStr) => {
        if (branchTypeStr === 'Branch') {
            return 1;
        } else {
            return 2;
        }
    }
    const onChangeRecordType = (e) => {
        let bType = branchTypeStringToInt(e.target.value);
        setRecordType(bType);
    }

    let sectionTypes = ['Receipt', 'Payment'];
    const sectionTypeStringToInt = (str) => {
        if (str === 'Receipt') {
            return 1;
        } else {
            return 2;
        }
    }
    const onChangeReceiptPayment = (e) => {
        let type = sectionTypeStringToInt(e.target.value);
        setReceiptPayment(type);
    }

    let vatTypeStrings = ['Not applicable', 'VAT Input', 'VAT Output', 'VAT Collect'];
    const vatTypeStringToInt = (str) => {
        if (str === 'VAT Input') {
            return 1;
        } else if (str === 'VAT Output') {
            return 2;
        } else if (str === 'VAT Collect') {
            return 3;
        } else {
            return 0;
        }
    }
    const onChangeVATType = (e) => {
        let type = vatTypeStringToInt(e.target.value);
        setVATAccountType(type);
    }

    let journalUsageStrings = ['Not applicable', 'General', 'Depreciation'];
    const journalUsageStringToInt = (str) => {
        if (str === 'General') {
            return 1;
        } else if (str === 'Depreciation') {
            return 2;
        } else {
            return 0;
        }
    }
    const onChangeJournalUsage = (e) => {
        let type = journalUsageStringToInt(e.target.value);
        setJournalUsage(type);
    }

    const onSelectGridItem = (item) => {
        setSelectedAnalysisCodeId(item.Id);
        setSelectedAnalysisCode(item);
    }

    const getSectionNumberFromSectionDescription = (recordType, accountingYear, fundTypeCode, sectionDescription, receiptPayment) => {
        let sectionNumber = 0;
        for (let i = 0; i < accountSections.length; i ++) {
            if (accountSections[i].RecordType === recordType && accountSections[i].AccountingYear === accountingYear && accountSections[i].FundTypeCode === fundTypeCode && accountSections[i].SectionDescription === sectionDescription && accountSections[i].ReceiptPayment === receiptPayment) {
                sectionNumber = accountSections[i].SectionNumber;
                break;
            }
        }
        return sectionNumber;
    }

    const getSectionDescriptionFromSectionNumber = (recordType, accountingYear, fundTypeCode, sectionNumber, receiptPayment) => {
        let sectionDescription = '';
        for (let i = 0; i < accountSections.length; i ++) {
            if (accountSections[i].RecordType === recordType && accountSections[i].AccountingYear === accountingYear && accountSections[i].FundTypeCode === fundTypeCode && accountSections[i].SectionNumber === sectionNumber && accountSections[i].ReceiptPayment === receiptPayment) {
                sectionDescription = accountSections[i].SectionDescription;
                break;
            }
        }
        return sectionDescription;
    }

    const fetchFundSections = async () => {
        try {
            let accountSectionList = [];
            let accountSectionNameList = [];

            const resp = (await request('database', 'fetchFundSections'));
            if (resp.ok) {
                resp.data.map((accountSection, index) => {
                    accountSectionList.push(accountSection);
                    accountSectionNameList.push(accountSection.SectionDescription);
                });
                setAccountSections(accountSectionList);
                setSectionNameStrings(accountSectionNameList);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch fund sections: ', e);
            return false;
        }
        return true;
    }
    
    const fetchFundTypes = async () => {
        try {
            let tabs = [];

            const resp = (await request('database', 'fetchFundTypes'));
            if (resp.ok) {
                resp.data.map((fundType, index) => {
                    if (fundType.AccountingYear === props.baseYear && !tabs.find((itm) => itm.FundTypeCode === fundType.FundTypeCode)) {
                        tabs.push({text: fundType.FundTypeCode.replace(/\s/g, '') + ' - ' + fundType.FundTypeName, path: fundType.FundTypeCode.replace(/\s/g, ''), FundTypeCode: fundType.FundTypeCode})
                    }
                });
                setTabs(tabs);
                setIsFetchedAccountTypes(true);
                if (tabs.length > 0) {
                    if (!subTabPath) {
                        navigate(defaultPath + tabs[0].path);
                    } else {
                        let selectedTab = tabs.find((itm) => itm.FundTypeCode.replace(/\s/g, '') === subTabPath);
                        if (selectedTab) {
                            setSelectedFundTypeCode(selectedTab.FundTypeCode);
                        }
                    }
                }
            } else {
                console.log('Failed fetchFundTypes');
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch fund types: ', e);
            return false;
        }
        return true;
    }

    const fetchAnalysisCodes = async (recordTypeToSelect, sectionNumberToSelect, accountCodeToSelect) => {
        try {
            let accountSectionList = [];

            const resp = (await request('database', 'fetchAnalysisCodes'));
            if (resp.ok) {
                resp.data.map((accountSection, index) => {
                    accountSectionList.push(accountSection);
                });
                setAnalysisCodes(accountSectionList);
                rebuildGridData(accountSectionList, recordTypeToSelect, sectionNumberToSelect, accountCodeToSelect);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch analysis codes: ', e);
            return false;
        }
        return true;
    }

    const onDeleteAnalysisCode = async () => {
        if (selectedAnalysisCode && selectedFundTypeCode) {
            setIsDeleting(true);
            let deleteData = {};
            deleteData.RecordType = selectedAnalysisCode.RecordType;
            deleteData.AccountingYear = selectedAnalysisCode.AccountingYear;
            deleteData.SectionNumber = selectedAnalysisCode.SectionNumber;
            deleteData.FundTypeCode = selectedFundTypeCode;
            deleteData.AnalysisCode = selectedAnalysisCode.AnalysisCode;
            deleteData.AccountCode = selectedAnalysisCode.AccountCode;
            
            const resp = (await request('database', 'deleteAnalysisCode', [deleteData]));
            if (resp.ok) {
                setSelectedAnalysisCode(null);
                setSelectedAnalysisCodeId(null);
                fetchAnalysisCodes();
                NotificationManager.success('Successfully deleted analysis code');
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeleting(false);
        }
    }

    const onSaveChanges = async () => {
        if (isAddAnalysisCodeMode) { // adding new item
            if (analysisCodeDescription === '' || analysisCode.length !== 1 || accountCode === '') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (analysisCodes.length > 0 && (analysisCodes.find((itm) => itm.RecordType === recordType && itm.AccountingYear === accountingYear && itm.FundTypeCode.replace(/\s/g, '') === selectedFundTypeCode.replace(/\s/g, '') && itm.SectionNumber === getSectionNumberFromSectionDescription(recordType, accountingYear, selectedFundTypeCode, sectionName, receiptPayment) && itm.AnalysisCode === analysisCode))) {
                    setIsAddingDuplicatedAnalysisCode(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.SectionNumber = getSectionNumberFromSectionDescription(recordType, accountingYear, selectedFundTypeCode, sectionName, receiptPayment)
                    saveData.FundTypeCode = selectedFundTypeCode;
                    saveData.AnalysisCodeDescription = analysisCodeDescription;
                    saveData.AnalysisCode = analysisCode;
                    saveData.ReceiptPayment = receiptPayment;
                    saveData.AccountCode = accountCode;
                    saveData.VATAccountType = VATAccountType;
                    saveData.JournalUsage = journalUsage;
                    saveData.AllowSubAnalysisCodes = allowSubAnalysisCodes;
                    saveData.IsTransfers = isTransfers;
                    saveData.DoNotDisplay = doNotDisplay;

                    const resp = (await request('database', 'createAnalysisCode', [saveData]));
                    if (resp.ok) {
                        fetchAnalysisCodes(recordType, saveData.SectionNumber. accountCode);
                        NotificationManager.success('Successfully added analysis code');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddAnalysisCodeMode(false);
                }
            }
        } else {
            if (analysisCodeDescription === '' || analysisCode.length !== 1 || accountCode === '') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (analysisCodes.length > 0 && (analysisCodes.find((itm) => (itm.RecordType !== selectedAnalysisCode.RecordType || itm.AccountingYear !== selectedAnalysisCode.AccountingYear || itm.FundTypeCode.replace(/\s/g, '') !== selectedFundTypeCode.replace(/\s/g, '') || itm.SectionNumber !== selectedAnalysisCode.SectionNumber || itm.AnalysisCode !== selectedAnalysisCode.AnalysisCode) && itm.RecordType === recordType && itm.AccountingYear === accountingYear && itm.FundTypeCode.replace(/\s/g, '') === selectedFundTypeCode.replace(/\s/g, '') && itm.SectionNumber === getSectionNumberFromSectionDescription(recordType, accountingYear, selectedFundTypeCode, sectionName, receiptPayment) && itm.AnalysisCode === analysisCode))) {
                    setIsAddingDuplicatedAnalysisCode(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.SectionNumber = getSectionNumberFromSectionDescription(recordType, accountingYear, selectedFundTypeCode, sectionName, receiptPayment);
                    saveData.FundTypeCode = selectedFundTypeCode;
                    saveData.AnalysisCodeDescription = analysisCodeDescription;
                    saveData.AnalysisCode = analysisCode;
                    saveData.ReceiptPayment = receiptPayment;
                    saveData.AccountCode = accountCode;
                    saveData.VATAccountType = VATAccountType;
                    saveData.JournalUsage = journalUsage;
                    saveData.AllowSubAnalysisCodes = allowSubAnalysisCodes;
                    saveData.IsTransfers = isTransfers;
                    saveData.DoNotDisplay = doNotDisplay;

                    saveData.OldRecordType = selectedAnalysisCode.RecordType;
                    saveData.OldAccountingYear = selectedAnalysisCode.AccountingYear;
                    saveData.OldSectionNumber = selectedAnalysisCode.SectionNumber;
                    saveData.OldFundTypeCode = selectedAnalysisCode.FundTypeCode;
                    saveData.OldAnalysisCode = selectedAnalysisCode.AnalysisCode;
                    saveData.OldAccountCode = selectedAnalysisCode.AccountCode;

                    const resp = (await request('database', 'updateAnalysisCode', [saveData]));
                    if (resp.ok) {
                        fetchAnalysisCodes(recordType, saveData.SectionNumber, accountCode);
                        NotificationManager.success('Successfully updated analysis code');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddAnalysisCodeMode(false);
                }
            }
        }
    }

    const rebuildGridData = (analysisCodes, recordTypeToSelect, sectionNumberToSelect, accountCodeToSelect) => {
        if (analysisCodes && analysisCodes.length > 0) {
            let branchAnalysisCodes = [];
            let subBranchAnalysisCodes = [];
            let sectionNumberStringsForBranch = [];
            let sectionNumberStringsForSubBranch = [];
            let prevSectionNumber = -1;
            let subArrBranches = [];
            let subArrSubBranches = [];

            let selectGridItem;
            let selectGridItemId;

            analysisCodes.sort((a,b) => {return a.SectionNumber < b.SectionNumber ? -1 : 1}).map((analysisCode, index) => {
                if (analysisCode.AccountingYear === props.baseYear && analysisCode.FundTypeCode.replace(/\s/g, '') === selectedFundTypeCode.replace(/\s/g, '')) {
                    let gridItem = {Id: index,
                                    'Code': analysisCode.AnalysisCode,
                                    'Description': analysisCode.AnalysisCodeDescription,
                                    ...analysisCode};
                    if (analysisCode.SectionNumber !== prevSectionNumber) {
                        if (prevSectionNumber !== -1) {
                            if (subArrBranches.length > 0) {
                                branchAnalysisCodes.push(structuredClone(subArrBranches));
                                subArrBranches.splice(0, subArrBranches.length);
                            }
                            if (subArrSubBranches.length > 0) {
                                subBranchAnalysisCodes.push(structuredClone(subArrSubBranches));
                                subArrSubBranches.splice(0, subArrSubBranches.length);
                            }
                        }
                        if (analysisCode.RecordType === 1) {
                            sectionNumberStringsForBranch.push("Section " + analysisCode.SectionNumber);
                        } else {
                            sectionNumberStringsForSubBranch.push("Section " + analysisCode.SectionNumber);
                        }

                        prevSectionNumber = analysisCode.SectionNumber;
                    }
                    if (analysisCode.RecordType === 1) {
                        subArrBranches.push(gridItem);
                    } else {
                        subArrSubBranches.push(gridItem);
                    }
                    if (recordTypeToSelect && sectionNumberToSelect && accountCodeToSelect && analysisCode.RecordType === recordTypeToSelect && analysisCode.SectionNumber === sectionNumberToSelect && analysisCode.AccountCode.replace(/\s/g, '') === accountCodeToSelect.replace(/\s/g, '')) {
                        selectGridItem = gridItem;
                        selectGridItemId = index;
                    }
                }
            });
            if (subArrBranches.length > 0) {
                branchAnalysisCodes.push(structuredClone(subArrBranches));
            }
            if (subArrSubBranches.length > 0) {
                subBranchAnalysisCodes.push(structuredClone(subArrSubBranches));
            }
            setGridData({groups: [{name: 'Type: Branches', subGroups: sectionNumberStringsForBranch}, {name: 'Type: Sub-branches', subGroups: sectionNumberStringsForSubBranch}], items: [branchAnalysisCodes, subBranchAnalysisCodes]});
            setSelectedAnalysisCodeId(selectGridItemId);
            setSelectedAnalysisCode(selectGridItem);
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            props.setPageTitle('Account section codes');
            fetchAnalysisCodes();
            fetchFundSections();
            setLoadedPage(true);
        }

        fetchFundTypes();
        rebuildGridData(analysisCodes);
        setAccountingYear(props.baseYear);
    }, [props.baseYear]);

    useEffect(() => {
        rebuildGridData(analysisCodes);
    }, [analysisCodes]);

    useEffect(() => {
        rebuildGridData(analysisCodes);

        setRecordType(1);
        setAccountingYear(props.baseYear);
        if (accountSections.length > 0) {
            setSectionName(accountSections[0].SectionDescription);
        } else {
            setSectionName('None');
        }
        setAnalysisCodeDescription('');
        setAnalysisCode('');
        setReceiptPayment(1);
        setAccountCode('');
        setVATAccountType(0);
        setJournalUsage(0);
        setAllowSubAnalysisCodes(false);
        setIsTransfers(false);
        setDoNotDisplay(false);

        setSelectedAnalysisCode(null);
        setSelectedAnalysisCodeId(null);
        setNeedsValidation(false);
    }, [selectedFundTypeCode]);

    useEffect(() => {
        if (tabs.length > 0) {
            let selectedTab = tabs.find((itm) => itm.FundTypeCode.replace(/\s/g, '') === subTabPath);
            if (selectedTab) {
                setSelectedFundTypeCode(selectedTab.FundTypeCode);
            }
        }
    }, [subTabPath]);

    useEffect(() => {
        if (isAddAnalysisCodeMode) {
            setNeedsValidation(false);

            setRecordType(1);
            setAccountingYear(props.baseYear);
            if (accountSections.length > 0) {
                setSectionName(accountSections[0].SectionDescription);
            } else {
                setSectionName('None');
            }
            setAnalysisCodeDescription('');
            setAnalysisCode('');
            setReceiptPayment(1);
            setAccountCode('');
            setVATAccountType(0);
            setJournalUsage(0);
            setAllowSubAnalysisCodes(false);
            setIsTransfers(false);
            setDoNotDisplay(false);
        } else if (selectedAnalysisCode) {
            setNeedsValidation(false);

            setRecordType(selectedAnalysisCode.RecordType);
            setAccountingYear(selectedAnalysisCode.AccountingYear);
            setSectionName(getSectionDescriptionFromSectionNumber(selectedAnalysisCode.RecordType, selectedAnalysisCode.AccountingYear, selectedAnalysisCode.FundTypeCode, selectedAnalysisCode.SectionNumber, selectedAnalysisCode.ReceiptPayment));
            setAnalysisCodeDescription(selectedAnalysisCode.AnalysisCodeDescription);
            setAnalysisCode(selectedAnalysisCode.AnalysisCode);
            setReceiptPayment(selectedAnalysisCode.ReceiptPayment);
            setAccountCode(selectedAnalysisCode.AccountCode);
            setVATAccountType(selectedAnalysisCode.VATAccountType);
            setJournalUsage(selectedAnalysisCode.JournalUsage);
            setAllowSubAnalysisCodes(selectedAnalysisCode.AllowSubAnalysisCodes);
            setIsTransfers(selectedAnalysisCode.IsTransfers);
            setDoNotDisplay(selectedAnalysisCode.DoNotDisplay);
        }
    }, [isAddAnalysisCodeMode]);

    useEffect(() => {
        if (selectedAnalysisCode) {
            setRecordType(selectedAnalysisCode.RecordType);
            setAccountingYear(selectedAnalysisCode.AccountingYear);
            setSectionName(getSectionDescriptionFromSectionNumber(selectedAnalysisCode.RecordType, selectedAnalysisCode.AccountingYear, selectedAnalysisCode.FundTypeCode, selectedAnalysisCode.SectionNumber, selectedAnalysisCode.ReceiptPayment));
            setAnalysisCodeDescription(selectedAnalysisCode.AnalysisCodeDescription);
            setAnalysisCode(selectedAnalysisCode.AnalysisCode);
            setReceiptPayment(selectedAnalysisCode.ReceiptPayment);
            setAccountCode(selectedAnalysisCode.AccountCode);
            setVATAccountType(selectedAnalysisCode.VATAccountType);
            setJournalUsage(selectedAnalysisCode.JournalUsage);
            setAllowSubAnalysisCodes(selectedAnalysisCode.AllowSubAnalysisCodes);
            setIsTransfers(selectedAnalysisCode.IsTransfers);
            setDoNotDisplay(selectedAnalysisCode.DoNotDisplay);
        } else {
            setNeedsValidation(false);

            setRecordType(1);
            setAccountingYear(props.baseYear);
            if (accountSections.length > 0) {
                setSectionName(accountSections[0].SectionDescription);
            } else {
                setSectionName('None');
            }
            setAnalysisCodeDescription('');
            setAnalysisCode('');
            setReceiptPayment(1);
            setAccountCode('');
            setVATAccountType(0);
            setJournalUsage(0);
            setAllowSubAnalysisCodes(false);
            setIsTransfers(false);
            setDoNotDisplay(false);
        }
    }, [selectedAnalysisCode]);

    useEffect(() => {
        setIsAddingDuplicatedAnalysisCode(false);
    }, [recordType, accountingYear, selectedFundTypeCode, sectionName]);

    useEffect(() => {
        setIsAddingDuplicatedAnalysisCode(false);
        setNeedsValidation(false);
    }, [props.baseYear, selectedAnalysisCode, isAddAnalysisCodeMode]);

    return (
        <StyledAccountSectionCodes>
            {tabs.length > 0 && <>
            <div style={{marginLeft:30}}>
                <TabBar tabs={tabs} defaultPath={defaultPath} selectedSubTabPath={subTabPath ? subTabPath : defaultTabPath}></TabBar>
            </div>
            <WhiteBoard>
                <div style={{display:'flex'}}>
                    <div>
                        <Grid2Groups id='account_section_codes_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddAnalysisCodeMode} itemIdToSelect={selectedAnalysisCodeId} onSelectGridItem={onSelectGridItem} gridStyle={{width:300, height:400}}></Grid2Groups>
                        <div style={{marginTop:20}}>
                            {selectedAnalysisCode && !isAddAnalysisCodeMode && <SecondaryButton caption='Delete' isLoading={isDeleting} onClick={() => onDeleteAnalysisCode()} style={{width:75, height:25}}></SecondaryButton>}
                            {isAddAnalysisCodeMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddAnalysisCodeMode(false)} style={{width:75, height:25, float:'right'}}></SecondaryButton>}
                            {!isAddAnalysisCodeMode && <PrimaryButton caption='Create new' onClick={() => setIsAddAnalysisCodeMode(true)} style={{width:100, height:25, float:'right'}}></PrimaryButton>}
                        </div>
                    </div>
                    <div style={{marginLeft:30}}>
                        <div style={{display:'flex'}}>
                            <FormSelectWithLabel label='Type' items={branchTypes} value={branchTypes[recordType-1]} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} onChange={(e) => onChangeRecordType(e)} style={{width:220, height:35, paddingLeft:10}} selectStyle={{paddingTop:0}}></FormSelectWithLabel>
                            <FormSelectWithLabel label='Year' items={years} value={accountingYear} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} onChange={(e) => setAccountingYear(parseInt(e.target.value))} style={{width:100, height:35, paddingLeft:10, marginLeft:30}} selectStyle={{paddingTop:0}} labelStyle={{marginLeft:30}}></FormSelectWithLabel>
                        </div>

                        <div style={{display:'flex'}}>
                            <FormSelectWithLabel label='Section' items={sectionNameStrings} value={sectionName} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} onChange={(e) => setSectionName(e.target.value)} style={{width:220, height:35, paddingLeft:10}}></FormSelectWithLabel>
                            <FormStringInput label='Account type' value={selectedFundTypeCode} disabled={true} inputStyle={{width:100}} style={{marginLeft:30}}></FormStringInput>
                        </div>
                        
                        <div style={{display:'flex', marginTop:15}}>
                            <FormStringInput label='Description' value={analysisCodeDescription} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} validated={needsValidation && analysisCodeDescription.length===0 ? false : undefined} onChange={(val) => setAnalysisCodeDescription(val)} inputStyle={{width:220}}></FormStringInput>
                            <FormStringInput label='Code' value={analysisCode} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} validated={needsValidation && analysisCode.length!==1 ? false : undefined} onChange={(val) => setAnalysisCode(val)} inputStyle={{width:100}} style={{marginLeft:30}}></FormStringInput>
                        </div>

                        <div style={{display:'flex'}}>
                            <FormSelectWithLabel label='Section code type' items={sectionTypes} value={sectionTypes[receiptPayment-1]} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} onChange={(e) => onChangeReceiptPayment(e)} style={{width:220, height:35, paddingLeft:10}}></FormSelectWithLabel>
                            <FormStringInput label='Account code' value={accountCode} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} validated={needsValidation && accountCode.length===0 ? false : undefined} onChange={(val) => setAccountCode(val)} inputStyle={{width:100}} style={{marginLeft:30}}></FormStringInput>
                        </div>

                        <div style={{display: 'flex', marginTop: 15}}>
                            <FormSelectWithLabel label='VAT type' items={vatTypeStrings} value={vatTypeStrings[VATAccountType]} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} onChange={(e) => onChangeVATType(e)} style={{width:160, height:35, paddingLeft:10}}></FormSelectWithLabel>
                            <FormSelectWithLabel label='Journal usage' items={journalUsageStrings} value={journalUsageStrings[journalUsage]} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} onChange={(e) => onChangeJournalUsage(e)} style={{width:160, height:35, paddingLeft:10}} selectStyle={{marginLeft:30}}></FormSelectWithLabel>
                        </div>

                        <FormCheckBoxWithRightLabel label='Allow sub-analysis codes' checked={allowSubAnalysisCodes} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} onCheck={(val) => setAllowSubAnalysisCodes(val)} style={{paddingTop:30}}></FormCheckBoxWithRightLabel>
                        <FormCheckBoxWithRightLabel label='Transfers' checked={isTransfers} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} onCheck={(val) => setIsTransfers(val)} style={{paddingTop:12}}></FormCheckBoxWithRightLabel>
                        <FormCheckBoxWithRightLabel label='Do not display' checked={doNotDisplay} disabled={!isAddAnalysisCodeMode && !selectedAnalysisCode} onCheck={(val) => setDoNotDisplay(val)} style={{paddingTop:12}}></FormCheckBoxWithRightLabel>

                        {isAddingDuplicatedAnalysisCode && <div style={{marginTop:20, width:280, fontSize:12, fontWeight:700, color:'#dc3545'}}>* Analysis code is duplicated.</div>}
                    </div>
                </div>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={isAddAnalysisCodeMode ? 'Add analysis code' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddAnalysisCodeMode || selectedAnalysisCode ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
            </>}
            {(tabs.length === 0 && isFetchedAccountTypes) && <h4 style={{marginLeft:30}}>No account types in {props.baseYear}</h4>}
        </StyledAccountSectionCodes>
    )
}

export default AccountSectionCodes;